import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { obtenerListaEmpresaPlataforma } from "../api/api-empresa-plataforma";
import { getListGrupoByIdEmpresaPlataforma } from "../api/api-grupo";

export default function ModalFormSubGroup({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const [listEmpresas, setListEmpresas] = useState([]);
    const [empresaSelected, setEmpresaSelected] = useState(null);
    const [listGrupo, setListGrupo] = useState([]);
    const [grupoSelected, setGrupoSelected] = useState(null);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);
            const listEmpresas = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            // console.log('listEmpresas');
            // console.log(listEmpresas);
            setListEmpresas(listEmpresas);
            if (formData.idEmpresaPlataforma === null) {
                setEmpresaSelected(null);
                setGrupoSelected(null);
            }
            if (formData.idEmpresaPlataforma !== null && String(formData.idEmpresaPlataforma).length > 0) {
                const empresa = listEmpresas.find(e => e.value === formData.idEmpresaPlataforma);
                // console.log('listEmpresas');
                // console.log(listEmpresas);
                setEmpresaSelected(empresa);

                if (formData.idGrupo !== null && String(formData.idGrupo).length > 0) {
                    const listGrupos = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: formData.idEmpresaPlataforma });
                    // console.log('listGrupos');
                    // console.log(listGrupos);
                    const grupo = listGrupos.find(e => e.value === formData.idGrupo);
                    setGrupoSelected(grupo);
                }

            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    useEffect(() => {
        checkGrupos();
    }, [empresaSelected]);

    const checkGrupos = async () => {
        // console.log('traer grupo de empresa selected');
        if (empresaSelected === null) {
            setListGrupo([]);
            setGrupoSelected(null);
            return;
        }
        const listGrupos = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: empresaSelected.value });
        // console.log('listGrupos');
        // console.log(listGrupos);
        setListGrupo(listGrupos);
        if (formData.idGrupo !== null && String(formData.idGrupo).length > 0) {
            const grupo = listGrupos.find(e => e.value === formData.idGrupo);
            setGrupoSelected(grupo);
        }
    }

    const charLimits = {
        codigo: 32,
        nombre: 32,
        nota: 128,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            // console.log('empresaSelected');
            // console.log(empresaSelected);
            // console.log('grupoSelected');
            // console.log(grupoSelected);
            // console.log('formData');
            // console.log(formData);
            let message = "";
            if (empresaSelected === undefined || empresaSelected === null) {
                message = message + t("alert_must_select_company") + '\n';
            }
            if (grupoSelected === undefined || grupoSelected === null) {
                message = message + t("alert_must_select_group") + '\n';
            }
            if (String(formData.nombre).trim().length === 0) {
                message = message + t("alert_must_enter_name") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            formData.idEmpresaPlataforma = empresaSelected.value;
            formData.idGrupo = grupoSelected.value;
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            codigo: "",
            nombre: "",
            nota: "",
        });
        setEmpresaSelected(null);
        setGrupoSelected(null);
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white sm:p-2 md:p-4 lg:p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
                        {/* <div className="rounded-lg w-1/2"> */}
                        {/* EMPRESA PLATAFORMA */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_empresa")}<span className="text-red-500">*</span></label>
                            <Select
                                options={listEmpresas}
                                isSearchable={true}
                                isClearable={true}
                                value={empresaSelected}
                                onChange={(event) => {
                                    setEmpresaSelected(event);
                                    if (event === null) {
                                        formData.idEmpresaPlataforma = null;
                                    }
                                    if (event !== null) {
                                        formData.idEmpresaPlataforma = event.value;
                                    }
                                }}
                                placeholder={t("label_select_empresa")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        {/* </div>
                        <div className="rounded-lg w-1/2">
                        </div> */}
                        {/* GRUPO */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_group")}<span className="text-red-500">*</span></label>
                            <Select
                                options={listGrupo}
                                isSearchable={true}
                                isClearable={true}
                                value={grupoSelected}
                                onChange={(event) => {
                                    setGrupoSelected(event);
                                    if (event === null) {
                                        formData.idGrupo = null;
                                    }
                                    if (event !== null) {
                                        formData.idGrupo = event.value;
                                    }
                                }}
                                placeholder={t("label_select_empresa")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("code")}</label>
                            <input
                                name="codigo"
                                value={formData.codigo}
                                onChange={handleInputChange}
                                placeholder={t("enter_code")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_nombre_sub_grupo")}<span className="text-red-500">*</span></label>
                            <input
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                placeholder={t("placeholder_enter_sub_group")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("note")}</label>
                            <input
                                name="nota"
                                value={formData.nota}
                                onChange={handleInputChange}
                                placeholder={t("enter_note")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nota.length}/{charLimits.nota}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
